import CloudflareSection from './cache/CloudflareSection';

export default function Cache() {
	return (
		<div class="ap-space-y-8">
			<CloudflareSection />
		</div>
	);
}
